import TabelProxy from "./TabelProxy";

export default TabelProxy;